import type { CmsBlock } from '@hubblecommerce/hubble/platforms/shopware/api-client'
import type { HblBlock } from '@/utils/types'
import { hblMapMedia, hblMediaIncludes, hblMapSlots, hblSlotIncludes } from '#imports'

export const hblBlockIncludes = {
    'cms_block': [
        'versionId',
        'type',
        'slots',
        'customFields',
        'cssClass',
        'backgroundColor',
        'backgroundMedia',
        'backgroundMediaMode',
        'sectionPosition',
        'marginTop',
        'marginRight',
        'marginBottom',
        'marginLeft',
        'visibility',
    ],
    ...hblSlotIncludes,
    ...hblMediaIncludes,
}

export function hblMapBlocks (swBlocks: CmsBlock[]): HblBlock[] {
    return swBlocks.map((block: CmsBlock) => {
        return {
            id: block.versionId as string,
            type: block.type,
            slots: hblMapSlots(block.slots),
            ...(block.customFields != null && {customFields: block.customFields}),
            ...(block.cssClass != null && { cssClass: block.cssClass }),
            ...(block.backgroundColor != null && { backgroundColor: block.backgroundColor }),
            ...(block.backgroundMedia != null && { backgroundMedia: hblMapMedia(block.backgroundMedia) }),
            ...(block.backgroundMediaMode != null && { backgroundMediaMode: block.backgroundMediaMode }),
            ...(block.sectionPosition != null && { sectionPosition: block.sectionPosition }),
            ...(block.marginTop != null && { marginTop: block.marginTop }),
            ...(block.marginRight != null && { marginRight: block.marginRight }),
            ...(block.marginBottom != null && { marginBottom: block.marginBottom }),
            ...(block.marginLeft != null && { marginLeft: block.marginLeft }),
            ...(block.visibility != null && { visibility: block.visibility })
        }
    })
}
